export default __webpack_public_path__ + "4dc5d5f914efe935e7de4e02933794dd.png";